import createIcon from '@/lib/create-icon'

const MMAIcon = createIcon(
  <svg
    id='filled-icon'
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='14'
    viewBox='0 0 46 35'
    fill='none'
  >
    <path
      stroke='none'
      d='M2.11681 26V8.144H6.79681L8.69281 16.568L8.95681 17.816H9.00481L9.24481 16.568L11.1408 8.144H15.8208V26H12.0048V17.792L12.1248 15.224H12.0768L11.8128 16.424L10.1568 23.36H7.78081L6.12481 16.424L5.86081 15.224H5.81281L5.93281 17.792V26H2.11681Z'
      fill='url(#paint0_linear_5442_507)'
    />
    <path
      stroke='none'
      d='M2.11681 26V8.144H6.79681L8.69281 16.568L8.95681 17.816H9.00481L9.24481 16.568L11.1408 8.144H15.8208V26H12.0048V17.792L12.1248 15.224H12.0768L11.8128 16.424L10.1568 23.36H7.78081L6.12481 16.424L5.86081 15.224H5.81281L5.93281 17.792V26H2.11681Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M2.11681 26V8.144H6.79681L8.69281 16.568L8.95681 17.816H9.00481L9.24481 16.568L11.1408 8.144H15.8208V26H12.0048V17.792L12.1248 15.224H12.0768L11.8128 16.424L10.1568 23.36H7.78081L6.12481 16.424L5.86081 15.224H5.81281L5.93281 17.792V26H2.11681Z'
      fill='url(#paint1_radial_5442_507)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M17.7965 26V8.144H22.4765L24.3725 16.568L24.6365 17.816H24.6845L24.9245 16.568L26.8205 8.144H31.5005V26H27.6845V17.792L27.8045 15.224H27.7565L27.4925 16.424L25.8365 23.36H23.4605L21.8045 16.424L21.5405 15.224H21.4925L21.6125 17.792V26H17.7965Z'
      fill='url(#paint2_linear_5442_507)'
    />
    <path
      stroke='none'
      d='M17.7965 26V8.144H22.4765L24.3725 16.568L24.6365 17.816H24.6845L24.9245 16.568L26.8205 8.144H31.5005V26H27.6845V17.792L27.8045 15.224H27.7565L27.4925 16.424L25.8365 23.36H23.4605L21.8045 16.424L21.5405 15.224H21.4925L21.6125 17.792V26H17.7965Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M17.7965 26V8.144H22.4765L24.3725 16.568L24.6365 17.816H24.6845L24.9245 16.568L26.8205 8.144H31.5005V26H27.6845V17.792L27.8045 15.224H27.7565L27.4925 16.424L25.8365 23.36H23.4605L21.8045 16.424L21.5405 15.224H21.4925L21.6125 17.792V26H17.7965Z'
      fill='url(#paint3_radial_5442_507)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M32.6122 26L36.1162 8.144H41.2522L44.7562 26H40.8202L40.3162 23.12H37.0522L36.5482 26H32.6122ZM37.5322 19.76H39.8362L38.9002 13.784L38.7082 12.296H38.6602L38.4922 13.784L37.5322 19.76Z'
      fill='url(#paint4_linear_5442_507)'
    />
    <path
      stroke='none'
      d='M32.6122 26L36.1162 8.144H41.2522L44.7562 26H40.8202L40.3162 23.12H37.0522L36.5482 26H32.6122ZM37.5322 19.76H39.8362L38.9002 13.784L38.7082 12.296H38.6602L38.4922 13.784L37.5322 19.76Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M32.6122 26L36.1162 8.144H41.2522L44.7562 26H40.8202L40.3162 23.12H37.0522L36.5482 26H32.6122ZM37.5322 19.76H39.8362L38.9002 13.784L38.7082 12.296H38.6602L38.4922 13.784L37.5322 19.76Z'
      fill='url(#paint5_radial_5442_507)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M0 0H21V4H0V0Z'
      fill='url(#paint6_linear_5442_507)'
    />
    <path stroke='none' d='M0 0H21V4H0V0Z' fill='white' fillOpacity='0.04' />
    <path
      stroke='none'
      d='M0 0H21V4H0V0Z'
      fill='url(#paint7_radial_5442_507)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M25 31H46V35H25V31Z'
      fill='url(#paint8_linear_5442_507)'
    />
    <path
      stroke='none'
      d='M25 31H46V35H25V31Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M25 31H46V35H25V31Z'
      fill='url(#paint9_radial_5442_507)'
      fillOpacity='0.6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5442_507'
        x1='0'
        y1='0'
        x2='42.5225'
        y2='38.8102'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5442_507'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 35) scale(23 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5442_507'
        x1='0'
        y1='0'
        x2='42.5225'
        y2='38.8102'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5442_507'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 35) scale(23 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5442_507'
        x1='0'
        y1='0'
        x2='42.5225'
        y2='38.8102'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5442_507'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 35) scale(23 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_5442_507'
        x1='0'
        y1='0'
        x2='42.5225'
        y2='38.8102'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_5442_507'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 35) scale(23 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_5442_507'
        x1='0'
        y1='0'
        x2='42.5225'
        y2='38.8102'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint9_radial_5442_507'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 35) scale(23 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'MMAIcon'
)

export default MMAIcon
